// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Used in the following:
    (updated: 2021.02.22)

    signin.html
*/
.ezPasswordShowHideImg {
  height: 24px;
  padding-top: 2px;
}

div.ezFixedDialogBox {
  margin: 25%;
  margin-top: 3%;
  padding: 30px;
  background-color: rgba(250, 250, 255, 0.85);
  border-width: 1px;
  border-style: solid;
  border-color: var(--ezClockerNavy);
  border-radius: 3px;
}

.ezFixedDialogLogoContainer {
  vertical-align: middle;
  text-align: center;
  font-size: 14pt;
  margin-bottom: 10px;
}

.ezFixedDialogLogoImage {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}

.ezFixedDialogSubBanner {
  text-align: center;
  font-size: 24pt;
  font-weight: normal;
  color: #808080;
}

.ezFixedDialogBanner {
  margin-bottom: 10px;
  color: #0f4777;
  font-size: 48pt;
  font-weight: bold;
}

.ezFixedDialogInputLabel {
  font-weight: bold;
  font-size: 16pt;
}

.ezFixedDialogInput {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  font-size: 18pt;
}

.ezDialogInputTitle {
  font-weight: bold;
  font-size: 16pt;
}

input.ezDialogTextInput {
  width: 100%;
  font-size: 18pt;
}

/** Password Viewer Styles **/
img.viewPasswordImage {
  display: none;
  width: 24px;
  height: 24px;
  padding: 0;
}

td.passwordPeekContainer {
  width: 24px;
  border-style: none;
  margin: 0;
  padding: 0;
}

div.passwordPeek {
  text-align: left;
  padding: 4px;
  /* 	background-color: #0f4777; */
  background-color: rgb(15 71 119/40%);
  color: #ffffff;
  font-weight: bold;
  font-family: monospace;
  font-size: 12pt;
  word-wrap: break-word;
  position: absolute;
  /* 	-webkit-box-shadow: 0px 0px 2px 2px rgba(109,110,112,1); */
  /* 	-moz-box-shadow: 0px 0px 2px 2px rgba(109,110,112,1); */
  /* 	box-shadow: 0px 0px 2px 2px rgba(109,110,112,1); */
  /* 	border-radius: 4px; */
}

div.passwordPeekBlank {
  text-align: left;
  font-style: italic;
}

.ui-effects-transfer {
  background-color: rgb(15 71 119/25%);
  border-style: dashed;
  border-width: 1px;
  border-color: #000000;
}

pre.visualPasswordSpace {
  border-left-style: solid;
  border-right-style: solid;
  border-top-style: none;
  border-bottom-style: none;
  border-width: 1px;
  border-color: #7cd0fd;
  padding: 0;
  margin: 0;
}

div.peekCountDown {
  text-align: center;
  display: hidden;
  color: #0f4777;
  font-size: 12pt;
  font-family: monospace;
  font-weight: bold;
}

div.signInBox {
  width: 30%;
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
  background-color: rgb(250 250 250/100%);
  border: 1px solid black;
  border-radius: 5px;
  margin-top: 35px;
}

td.signUpCell {
  padding-top: 20px;
  text-align: center;
}

td.inputCell {
  padding-bottom: 8px;
}

td.signInLabel {
  font-weight: bold;
  font-size: 16pt;
}

td.buttonCell {
  padding-top: 10px;
  padding-bottom: 10px;
}

div.signInBanner {
  text-align: center;
  font-size: 48pt;
  font-weight: bold;
}

div.errorBox {
  text-align: center;
  color: red;
  font-size: 14pt;
  display: none;
  padding-top: 8px;
  padding-bottom: 8px;
}

/*
    ===================================================================================================================
    [Class Group]
    Animated Sign-In Backgrounds
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignup-animated-gradient-background
        @-webkit-keyframes ezSignup-animated-gradient-background-keyframes
        @keyframes ezSignup-animated-gradient-background-keyframes
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignup-animated-gradient-background {
  width: 100%;
  height: 100vh;
  background-size: 300% 300%;
  background-image: linear-gradient(-45deg, rgba(255, 153, 0, 0.9) 0%, rgba(255, 153, 0, 0.9) 25%, rgba(255, 153, 0, 0.9) 50%, var(--ezClockerWhite) 100%);
  -webkit-animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;
  animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;
}

@-webkit-keyframes ezSignup-animated-gradient-background-keyframes {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes ezSignup-animated-gradient-background-keyframes {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignin-animated-blob-background-part1::before
        @keyframes ezSignin-animated-blob-background-part1-shape
        .ezSignin-animated-blob-background-part2::before
        @keyframes ezSignin-animated-blob-background-part2-shape
        .ezSignin-animated-blob-background-part3::before
        @keyframes ezSignin-animated-blob-background-part3-shape
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignin-animated-blob-background-part1::before {
  scale: 75%;
  position: absolute;
  content: "";
  left: 10%;
  top: 5%;
  width: 450px;
  height: 450px;
  background: rgba(15, 71, 119, 0.3);
  border-radius: 62% 47% 82% 35%/45% 45% 80% 66%;
  will-change: border-radius, transform, opacity;
  animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;
  display: block;
  z-index: -1;
  -webkit-animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;
}

@keyframes ezSignin-animated-blob-background-part1-shape {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  34% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 5px, 0) rotateZ(0.01deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  67% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, -3px, 0) rotateZ(0.01deg);
  }
}
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignin-animated-blob-background-slider-thumb::before
        @keyframes ezSignin-animated-blob-background-slider-shape
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignin-animated-blob-background-part2::before {
  scale: 75%;
  position: absolute;
  content: "";
  left: 35%;
  top: 40%;
  width: 450px;
  height: 450px;
  background: rgba(255, 153, 0, 0.5);
  border-radius: 62% 47% 82% 35%/45% 45% 80% 66%;
  will-change: border-radius, transform, opacity;
  animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;
  display: block;
  z-index: -1;
  -webkit-animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;
}

@keyframes ezSignin-animated-blob-background-part2-shape {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  34% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 5px, 0) rotateZ(0.01deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  67% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, -3px, 0) rotateZ(0.01deg);
  }
}
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezSignin-animated-blob-background
        .ezSignin-animated-blob-background-slider-thumb::before
        @keyframes ezSignin-animated-blob-background-slider-shape
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezSignin-animated-blob-background-part3::before {
  scale: 75%;
  position: absolute;
  content: "";
  left: 60%;
  top: 15%;
  width: 450px;
  height: 450px;
  background: rgba(109, 110, 112, 0.5);
  border-radius: 62% 47% 82% 35%/45% 45% 80% 66%;
  will-change: border-radius, transform, opacity;
  animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;
  display: block;
  z-index: -1;
  -webkit-animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;
}

@keyframes ezSignin-animated-blob-background-part3-shape {
  0%, 100% {
    border-radius: 42% 58% 70% 30%/45% 45% 55% 55%;
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  34% {
    border-radius: 70% 30% 46% 54%/30% 29% 71% 70%;
    transform: translate3d(0, 5px, 0) rotateZ(0.01deg);
  }
  50% {
    transform: translate3d(0, 0, 0) rotateZ(0.01deg);
  }
  67% {
    border-radius: 100% 60% 60% 100%/100% 100% 60% 60%;
    transform: translate3d(0, -3px, 0) rotateZ(0.01deg);
  }
}`, "",{"version":3,"sources":["webpack://./public/sign-in/ez-signin.css"],"names":[],"mappings":"AAAA;;;;;CAAA;AAMA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,2CAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAGA;EACI,iBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,WAAA;EACA,eAAA;AAAJ;;AAGA,6BAAA;AAEA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AADJ;;AAIA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AADJ;;AAIA;EACI,gBAAA;EACA,YAAA;EAEA,gCAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EAEA,8DAAA;EAEA,2DAAA;EAEA,sDAAA;EAEA,yBAAA;AANJ;;AASA;EACI,gBAAA;EACA,kBAAA;AANJ;;AASA;EACI,oCAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;AANJ;;AASA;EACI,wBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AANJ;;AASA;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AANJ;;AASA;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AASA;EACI,iBAAA;EACA,kBAAA;AANJ;;AASA;EACI,mBAAA;AANJ;;AASA;EACI,iBAAA;EACA,eAAA;AANJ;;AASA;EACI,iBAAA;EACA,oBAAA;AANJ;;AASA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AASA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AANJ;;AASA;;;;;CAAA;AAOA;;;;;;;;;;;;CAAA;AAaA;EACI,WAAA;EACA,aAAA;EACA,0BAAA;EACA,wJAAA;EAKA,oFAAA;EACA,4EAAA;AAXJ;;AAcA;EACI;IACI,2BAAA;EAXN;EAcE;IACI,6BAAA;EAZN;EAeE;IACI,2BAAA;EAbN;AACF;AAgBA;EACI;IACI,2BAAA;EAdN;EAiBE;IACI,6BAAA;EAfN;EAkBE;IACI,2BAAA;EAhBN;AACF;AAmBA;;;;;;;;;;;;CAAA;AAaA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,8CAAA;EACA,8CAAA;EACA,2EAAA;EACA,cAAA;EACA,WAAA;EACA,mFAAA;AAjBJ;;AAoBA;EAEI;IAEI,8CAAA;IACA,gDAAA;EAnBN;EAsBE;IACI,8CAAA;IACA,kDAAA;EApBN;EAuBE;IACI,gDAAA;EArBN;EAwBE;IACI,kDAAA;IACA,mDAAA;EAtBN;AACF;AAyBA;;;;;;;;;;;CAAA;AAYA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,8CAAA;EACA,8CAAA;EACA,2EAAA;EACA,cAAA;EACA,WAAA;EACA,mFAAA;AAvBJ;;AA0BA;EAEI;IAEI,8CAAA;IACA,gDAAA;EAzBN;EA4BE;IACI,8CAAA;IACA,kDAAA;EA1BN;EA6BE;IACI,gDAAA;EA3BN;EA8BE;IACI,kDAAA;IACA,mDAAA;EA5BN;AACF;AA+BA;;;;;;;;;;;;CAAA;AAaA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,8CAAA;EACA,8CAAA;EACA,2EAAA;EACA,cAAA;EACA,WAAA;EACA,mFAAA;AA7BJ;;AAgCA;EAEI;IAEI,8CAAA;IACA,gDAAA;EA/BN;EAkCE;IACI,8CAAA;IACA,kDAAA;EAhCN;EAmCE;IACI,gDAAA;EAjCN;EAoCE;IACI,kDAAA;IACA,mDAAA;EAlCN;AACF","sourcesContent":["/*\r\n    Used in the following:\r\n    (updated: 2021.02.22)\r\n\r\n    signin.html\r\n*/\r\n.ezPasswordShowHideImg {\r\n    height: 24px;\r\n    padding-top: 2px\r\n}\r\n\r\ndiv.ezFixedDialogBox {\r\n    margin: 25%;\r\n    margin-top: 3%;\r\n    padding: 30px;\r\n    background-color: rgba(250, 250, 255, 0.85);\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-color: var(--ezClockerNavy);\r\n    border-radius: 3px;\r\n}\r\n\r\n.ezFixedDialogLogoContainer {\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    font-size: 14pt;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.ezFixedDialogLogoImage {\r\n    width: 24px;\r\n    height: 24px;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezFixedDialogSubBanner {\r\n    text-align: center;\r\n    font-size: 24pt;\r\n    font-weight: normal;\r\n    color: #808080;\r\n}\r\n\r\n.ezFixedDialogBanner {\r\n    margin-bottom: 10px;\r\n    color: #0f4777;\r\n    font-size: 48pt;\r\n    font-weight: bold;\r\n\r\n}\r\n\r\n.ezFixedDialogInputLabel {\r\n    font-weight: bold;\r\n    font-size: 16pt;\r\n}\r\n\r\n.ezFixedDialogInput {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    width: 100%;\r\n    font-size: 18pt;\r\n}\r\n\r\n.ezDialogInputTitle {\r\n    font-weight: bold;\r\n    font-size: 16pt;\r\n}\r\n\r\ninput.ezDialogTextInput {\r\n    width: 100%;\r\n    font-size: 18pt;\r\n}\r\n\r\n/** Password Viewer Styles **/\r\n\r\nimg.viewPasswordImage {\r\n    display: none;\r\n    width: 24px;\r\n    height: 24px;\r\n    padding: 0;\r\n}\r\n\r\ntd.passwordPeekContainer {\r\n    width: 24px;\r\n    border-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\ndiv.passwordPeek {\r\n    text-align: left;\r\n    padding: 4px;\r\n\r\n    /* \tbackground-color: #0f4777; */\r\n    background-color: rgb(15 71 119 / 40%);\r\n    color: #ffffff;\r\n    font-weight: bold;\r\n    font-family: monospace;\r\n    font-size: 12pt;\r\n    word-wrap: break-word;\r\n    position: absolute;\r\n\r\n    /* \t-webkit-box-shadow: 0px 0px 2px 2px rgba(109,110,112,1); */\r\n\r\n    /* \t-moz-box-shadow: 0px 0px 2px 2px rgba(109,110,112,1); */\r\n\r\n    /* \tbox-shadow: 0px 0px 2px 2px rgba(109,110,112,1); */\r\n\r\n    /* \tborder-radius: 4px; */\r\n}\r\n\r\ndiv.passwordPeekBlank {\r\n    text-align: left;\r\n    font-style: italic;\r\n}\r\n\r\n.ui-effects-transfer {\r\n    background-color: rgb(15 71 119 / 25%);\r\n    border-style: dashed;\r\n    border-width: 1px;\r\n    border-color: #000000;\r\n}\r\n\r\npre.visualPasswordSpace {\r\n    border-left-style: solid;\r\n    border-right-style: solid;\r\n    border-top-style: none;\r\n    border-bottom-style: none;\r\n    border-width: 1px;\r\n    border-color: #7cd0fd;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\ndiv.peekCountDown {\r\n    text-align: center;\r\n    display: hidden;\r\n    color: #0f4777;\r\n    font-size: 12pt;\r\n    font-family: monospace;\r\n    font-weight: bold;\r\n}\r\n\r\ndiv.signInBox {\r\n    width: 30%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    padding: 30px;\r\n    background-color: rgb(250 250 250 / 100%);\r\n    border: 1px solid black;\r\n    border-radius: 5px;\r\n    margin-top: 35px;\r\n}\r\n\r\ntd.signUpCell {\r\n    padding-top: 20px;\r\n    text-align: center;\r\n}\r\n\r\ntd.inputCell {\r\n    padding-bottom: 8px;\r\n}\r\n\r\ntd.signInLabel {\r\n    font-weight: bold;\r\n    font-size: 16pt;\r\n}\r\n\r\ntd.buttonCell {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\ndiv.signInBanner {\r\n    text-align: center;\r\n    font-size: 48pt;\r\n    font-weight: bold;\r\n}\r\n\r\ndiv.errorBox {\r\n    text-align: center;\r\n    color: red;\r\n    font-size: 14pt;\r\n    display: none;\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n/*\r\n    ===================================================================================================================\r\n    [Class Group]\r\n    Animated Sign-In Backgrounds\r\n    ===================================================================================================================\r\n*/\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezSignup-animated-gradient-background\r\n        @-webkit-keyframes ezSignup-animated-gradient-background-keyframes\r\n        @keyframes ezSignup-animated-gradient-background-keyframes\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        all\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezSignup-animated-gradient-background {\r\n    width: 100%;\r\n    height: 100vh;\r\n    background-size: 300% 300%;\r\n    background-image: linear-gradient(-45deg,\r\n            rgba(255, 153, 0, 0.9) 0%,\r\n            rgba(255, 153, 0, 0.9) 25%,\r\n            rgba(255, 153, 0, 0.9) 50%,\r\n            var(--ezClockerWhite) 100%);\r\n    -webkit-animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;\r\n    animation: ezSignup-animated-gradient-background-keyframes 20s ease infinite;\r\n}\r\n\r\n@-webkit-keyframes ezSignup-animated-gradient-background-keyframes {\r\n    0% {\r\n        background-position: 0% 50%;\r\n    }\r\n\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n\r\n    100% {\r\n        background-position: 0% 50%;\r\n    }\r\n}\r\n\r\n@keyframes ezSignup-animated-gradient-background-keyframes {\r\n    0% {\r\n        background-position: 0% 50%;\r\n    }\r\n\r\n    50% {\r\n        background-position: 100% 50%;\r\n    }\r\n\r\n    100% {\r\n        background-position: 0% 50%;\r\n    }\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezSignin-animated-blob-background-part1::before\r\n        @keyframes ezSignin-animated-blob-background-part1-shape\r\n        .ezSignin-animated-blob-background-part2::before\r\n        @keyframes ezSignin-animated-blob-background-part2-shape\r\n        .ezSignin-animated-blob-background-part3::before\r\n        @keyframes ezSignin-animated-blob-background-part3-shape\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezSignin-animated-blob-background-part1::before {\r\n    scale: 75%;\r\n    position: absolute;\r\n    content: \"\";\r\n    left: 10%;\r\n    top: 5%;\r\n    width: 450px;\r\n    height: 450px;\r\n    background: rgba(15, 71, 119, 0.3);\r\n    border-radius: 62% 47% 82% 35% / 45% 45% 80% 66%;\r\n    will-change: border-radius, transform, opacity;\r\n    animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;\r\n    display: block;\r\n    z-index: -1;\r\n    -webkit-animation: ezSignin-animated-blob-background-part1-shape 5s linear infinite;\r\n}\r\n\r\n@keyframes ezSignin-animated-blob-background-part1-shape {\r\n\r\n    0%,\r\n    100% {\r\n        border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\r\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    34% {\r\n        border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\r\n        transform: translate3d(0, 5px, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    50% {\r\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    67% {\r\n        border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\r\n        transform: translate3d(0, -3px, 0) rotateZ(0.01deg);\r\n    }\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezSignin-animated-blob-background-slider-thumb::before\r\n        @keyframes ezSignin-animated-blob-background-slider-shape\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        all\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezSignin-animated-blob-background-part2::before {\r\n    scale: 75%;\r\n    position: absolute;\r\n    content: \"\";\r\n    left: 35%;\r\n    top: 40%;\r\n    width: 450px;\r\n    height: 450px;\r\n    background: rgba(255, 153, 0, 0.5);\r\n    border-radius: 62% 47% 82% 35% / 45% 45% 80% 66%;\r\n    will-change: border-radius, transform, opacity;\r\n    animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;\r\n    display: block;\r\n    z-index: -1;\r\n    -webkit-animation: ezSignin-animated-blob-background-part2-shape 5s linear infinite;\r\n}\r\n\r\n@keyframes ezSignin-animated-blob-background-part2-shape {\r\n\r\n    0%,\r\n    100% {\r\n        border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\r\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    34% {\r\n        border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\r\n        transform: translate3d(0, 5px, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    50% {\r\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    67% {\r\n        border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\r\n        transform: translate3d(0, -3px, 0) rotateZ(0.01deg);\r\n    }\r\n}\r\n\r\n/*\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    [Class Definition]\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Classes:\r\n        .ezSignin-animated-blob-background\r\n        .ezSignin-animated-blob-background-slider-thumb::before\r\n        @keyframes ezSignin-animated-blob-background-slider-shape\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n    Defined states:\r\n        all\r\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n*/\r\n.ezSignin-animated-blob-background-part3::before {\r\n    scale: 75%;\r\n    position: absolute;\r\n    content: \"\";\r\n    left: 60%;\r\n    top: 15%;\r\n    width: 450px;\r\n    height: 450px;\r\n    background: rgba(109, 110, 112, 0.5);\r\n    border-radius: 62% 47% 82% 35% / 45% 45% 80% 66%;\r\n    will-change: border-radius, transform, opacity;\r\n    animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;\r\n    display: block;\r\n    z-index: -1;\r\n    -webkit-animation: ezSignin-animated-blob-background-part3-shape 5s linear infinite;\r\n}\r\n\r\n@keyframes ezSignin-animated-blob-background-part3-shape {\r\n\r\n    0%,\r\n    100% {\r\n        border-radius: 42% 58% 70% 30% / 45% 45% 55% 55%;\r\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    34% {\r\n        border-radius: 70% 30% 46% 54% / 30% 29% 71% 70%;\r\n        transform: translate3d(0, 5px, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    50% {\r\n        transform: translate3d(0, 0, 0) rotateZ(0.01deg);\r\n    }\r\n\r\n    67% {\r\n        border-radius: 100% 60% 60% 100% / 100% 100% 60% 60%;\r\n        transform: translate3d(0, -3px, 0) rotateZ(0.01deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
